import * as Yup from 'yup';

export const donorSpecieSchema = Yup.object().shape({
  description: Yup.string().required('Descrição é obrigatória.'),
  referenceNumber: Yup.string().required('Número de Referência é obrigatório.'),
  text: Yup.string().required('Texto é obrigatório.'),
});